import React from 'react'
import Response from './Response'
import BeatLoader from 'react-spinners/BeatLoader'

function Phrases({
  responses,
  exerciseNumber,
  title,
  sectionClass,
  onClick = () => {},
  onDoubleClick = () => {},
  hideGhosting = false,
  Help = () => <React.Fragment />
}) {
  var blockBootstrapClass = ''

  if (sectionClass === 'extra-large')
    blockBootstrapClass = 'col-xs-12 text-left'
  else if (sectionClass === 'large') blockBootstrapClass = 'col-xs-12'
  else if (sectionClass === 'medium') blockBootstrapClass = 'col-md-6'
  else if (sectionClass === 'small') blockBootstrapClass = 'col-sm-6 col-md-4'
  else if (sectionClass === 'extra-small')
    blockBootstrapClass = 'col-xs-6 col-sm-3'
  else console.error(`Unknown section class: ${sectionClass}`)

  let _responses = []
  for (var i = 0; i < responses.length; ) {
    var responsesList = []
    var phraseNumber
    do {
      /* 
                phraseNumber: entry['Phrase_Number'],
                responseNumber: entry['Response_Number'],
            
            */
      //error{phraseNumber: number, responseNumber: number}
      phraseNumber = responses[i].phraseNumber
      var responseList = responses[i++]
      responsesList.push(
        <Response
          onClick={onClick.bind(null, i, {
            phraseNumber: responseList.phraseNumber,
            responseNumber: responseList.responseNumber,
          })}
          onDoubleClick={onDoubleClick.bind(null, i)}
          hadPreviousError={!hideGhosting && responseList.previousError}
          response={responseList.response}
          nextResponse={responses[i]?.response}
          responseNumber={i}
          zeroWidthSpace={true}
          spacing={true}
        />
      )
    } while (responses?.[i]?.phraseNumber === phraseNumber)

    _responses.push(
      <div className={`${blockBootstrapClass} response-container w-100`}>
        {responsesList}
      </div>
    )
  }

  return (
    <React.Fragment>
      {responses.length === 0 ? (
        <div style={{ margin: '0 auto', display: 'table', height: '50vh' }}>
          <div
            style={{
              display: 'table-cell',
              verticalAlign: 'middle',
              textAlign: 'center',
            }}
          >
            <BeatLoader size={15} color={'#123abc'} loading={true} />
          </div>
        </div>
      ) : (
        <React.Fragment>
          <h1>
            Sight Phrases Exercise {exerciseNumber} - {title}
            <Help />
          </h1>
          <div
            id="probe-contents"
            className={`row content-block${
              sectionClass === 'extra-small' ? '-small' : ''
            } phrases-text`}
          >
            {_responses}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default Phrases
